module.exports = __webpack_public_path__ + "media/images/icons/approve-465cbe21a94ca24357e16dcc0a494fdf.svg";